"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var DrawWaves = /** @class */ (function () {
    function DrawWaves() {
        var _this = this;
        this.topicTeaser = document.querySelectorAll("[".concat(constants_1.DATA_TOPIC_TEASER, "]"));
        window.addEventListener('scroll', function () {
            _this.topicTeaser.forEach(function (teaser) {
                _this.drawWaves(teaser);
            });
        });
    }
    DrawWaves.prototype.drawWaves = function (elem) {
        var waves = elem.querySelectorAll('.wave');
        if (this.isInViewport(elem)) {
            waves.forEach(function (wave) {
                if (wave.getAttribute('data-wave') == 'left') {
                    wave.style.animation = '2s ease-in forwards wave_from_left';
                }
                else if (wave.getAttribute('data-wave') == 'right') {
                    wave.style.animation = '2s ease-in forwards wave_from_right';
                }
            });
        }
    };
    DrawWaves.prototype.isInViewport = function (elem) {
        var rect = elem.getBoundingClientRect();
        return (rect.top <= ((window.innerHeight || document.documentElement.clientHeight) / 4 * 3) &&
            rect.top >= 0);
    };
    return DrawWaves;
}());
exports.default = DrawWaves;
